import { render, staticRenderFns } from "./RequestFormIncidentGeneral.vue?vue&type=template&id=1a63823d&scoped=true&"
import script from "./RequestFormIncidentGeneral.vue?vue&type=script&lang=js&"
export * from "./RequestFormIncidentGeneral.vue?vue&type=script&lang=js&"
import style0 from "./RequestFormIncidentGeneral.vue?vue&type=style&index=0&id=1a63823d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63823d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a63823d')) {
      api.createRecord('1a63823d', component.options)
    } else {
      api.reload('1a63823d', component.options)
    }
    module.hot.accept("./RequestFormIncidentGeneral.vue?vue&type=template&id=1a63823d&scoped=true&", function () {
      api.rerender('1a63823d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/RequestFormIncidentGeneral.vue"
export default component.exports